import Api from 'api'

const config = {
  baseURL: '/api/app/v1/yandex',
}
const api = new Api(config)

api.fetchUsers = () => api.get('/users')

api.sendUsers = ({ ...rest }) => api.post('/users', { ...rest })

api.getNetworkAuthUrl = () => api.get('/oauth/auth-url')

export default api
